var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btx-ck-editor"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"disabled":_vm.disabled,"config":_vm.editorConfig},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }